import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { PartialRouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import AccountSettings from './content/pages/Setting';
import AccountSettingsS3 from './content/pages/Setting';
import ProtectedRoute, { SessionMaintained } from './components/ProtectedRoute';
import { AmacUrl, Page } from './common/routes';
import SidebarLayoutStatistics from './layouts/SidebarLayoutStatistics';
import SidebarUploadLayout from './layouts/UploadLayout';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

//Authentication
const Authentication = Loader(
  lazy(() => import('src/content/authentication/login2'))
);
const ResetPassword = Loader(
  lazy(() => import('src/content/authentication/ResetPassword'))
);
const UpdatePhone = Loader(
  lazy(() => import('src/content/authentication/UpdatePhone'))
);
const MFAMethod = Loader(
  lazy(() => import('src/content/authentication/MFAMethod'))
);
const MFACode = Loader(
  lazy(() => import('src/content/authentication/MFACode'))
);
const Register = Loader(
  lazy(() => import('src/content/authentication/register'))
);
const AWSauth = Loader(
  lazy(() => import('src/content/authentication/Awsauth'))
);
const AccountCreated = Loader(
  lazy(() => import('src/content/authentication/Accountcreated'))
);
const Forgetemail = Loader(
  lazy(
    () => import('src/content/authentication/forgetpassword/forgetcodeemail')
  )
);
const Forgetauth = Loader(
  lazy(() => import('src/content/authentication/forgetpassword/forgetcode'))
);
const Statistics = Loader(
  lazy(() => import('src/content/authentication/Analytics'))
);
const Candidates = Loader(
  lazy(() => import('src/content/authentication/Candidates'))
);
const Stats = Loader(
  lazy(() => import('src/content/authentication/Statistics'))
);
const VoterTurnout = Loader(
  lazy(() => import('src/content/authentication/VoterTurnout'))
);
const SamplePage = Loader(
  lazy(() => import('src/content/authentication/sample-page'))
);

const VoterTurnoutReduced = Loader(
  lazy(() => import('src/content/authentication/VoterTurnoutReduced'))
);
const VoterPopulation = Loader(
  lazy(() => import('src/content/authentication/VoterPopulation'))
);
const UploadLogin = Loader(
  lazy(() => import('src/content/authentication/UploadLogin'))
);
const CSVBucketUpload = Loader(
  lazy(() => import('src/content/authentication/CSVBucketUpload'))
);
const S3CSVBucketUpload = Loader(
  lazy(() => import('src/content/authentication/CSVBucketStateUpload'))
);

//Dashboard
const Home = Loader(
  lazy(() => import('src/content/dashboard/SearchUserClickHouse'))
);

//Pages
const Analytics = Loader(lazy(() => import('src/content/dashboard/Analytics')));
const PrimaryElections2025 = Loader(
  lazy(() => import('src/content/dashboard/PrimaryElection2025'))
);

const PrimaryElectionsNov2025 = Loader(
  lazy(() => import('src/content/dashboard/PrimaryElectionNov2025'))
);

const PrimaryElections2025Home = Loader(
  lazy(() => import('src/content/authentication/PrimaryElections2025Home'))
);
const ElectionNov2025Home = Loader(
  lazy(() => import('src/content/authentication/ElectionNov2025Home'))
);
const UsersManagement = Loader(
  lazy(() => import('src/content/dashboard/UserManagement'))
);
const CandidatesLogs = Loader(
  lazy(() => import('src/content/dashboard/CandidatesLogs'))
);
const Contacts = Loader(
  lazy(() => import('src/content/dashboard/Contacts'))
);
const CaptainsRelations = Loader(
  lazy(() => import('src/content/dashboard/CaptainsRelations'))
);


const Test = Loader(
  lazy(() => import('src/content/dashboard/Test'))
);
const VotersFuzzySearch = Loader(
  lazy(() => import('src/content/dashboard/VotersFuzzySearch'))
);

const VotersListing = Loader(
  lazy(() => import('src/content/dashboard/VotersListing'))
);
const CommunityDemographics = Loader(
  lazy(() => import('src/content/dashboard/Demographics'))
);
const CSVUpload = Loader(lazy(() => import('src/content/dashboard/CSVUpload')));

const SearchUserDynamoDB = Loader(
  lazy(() => import('src/content/dashboard/SearchUserDynamoDB'))
);
const SearchUserClickHouse = Loader(
  lazy(() => import('src/content/dashboard/Home'))
);
const LoginLogs = Loader(lazy(() => import('src/content/dashboard/Loginlogs')));
const VotersListingLogs = Loader(
  lazy(() => import('src/content/dashboard/VotersListingLogs'))
);
const AddOwnership = Loader(
  lazy(() => import('src/content/dashboard/AddOwnership'))
);
const CustomVotersListing = Loader(
  lazy(() => import('src/content/dashboard/CustomSearchUserClickHouse'))
);
const Reasons = Loader(
  lazy(() => import('src/content/dashboard/BallotReasons'))
);
const ChorplethMap = Loader(
  lazy(() => import('src/content/dashboard/ChorplethMap'))
);

// Status Pages
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

//Old Pages

// Applications

const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

// Components

const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

const routes: PartialRouteObject[] = [
  {
    path: '*',
    element: (
      <SessionMaintained>
        <SidebarLayoutStatistics />
      </SessionMaintained>
    ),
    children: [
      {
        path: `${Page.Statistics}`,
        element: <Statistics />
      },
      {
        path: `${Page.Candidates}`,
        element: <Candidates />
      },
      {
        path: `${Page.VotersGuide}`,
        element: <Candidates />
      },
      {
        path: Page.Stats,
        element: <Stats />
      },
      {
        path: `${Page.PrimaryElection2025Home}/`,
        element: <PrimaryElections2025Home />
      },
      {
        path: `${Page.ElectionNov2025Home}/`,
        element: <ElectionNov2025Home />
      }
      
      // {
      //   path: Page.VoterTurnout,
      //   element: <VoterTurnout />
      // },
      // {
      //   path: Page.VoterPopulation,
      //   element: <VoterPopulation />
      // }
    ]
  },
  {
    path: '*',
    element: (
      <SessionMaintained>
        <SidebarUploadLayout />
      </SessionMaintained>
    ),
    children: [
      {
        path: `${Page.CSVBucketUpload}`,
        element: <CSVBucketUpload />
      },
      {
        path: `${Page.S3CSVBucketUpload}`,
        element: <S3CSVBucketUpload />
      }
    ]
  },
  {
    path: '*',
    element: (
      <SessionMaintained>
        <BaseLayout />
      </SessionMaintained>
    ),
    children: [
      {
        path: '/',
        element: <Authentication />
      },
      {
        path: `${Page.Login}`,
        element: <Authentication />
      },
      {
        path: `${Page.CommunityDemographicsHome}/`,
        element: <VoterTurnoutReduced />
      },
      {
        path: `${Page.UploadLogin}`,
        element: <UploadLogin />
      },
      // {
      //   path: 'test',
      //   children: [
      //     {
      //       path: '/',
      //       element: <TestS3 />
      //     }
      //   ]
      // },
      {
        path: Page.Register,
        children: [
          {
            path: '/',
            element: <Register />
          }
        ]
      },
      {
        path: `${Page.Awsauth}/:authemail`,
        children: [
          {
            path: '/',
            element: <AWSauth />
          }
        ]
      },
      {
        path: Page.AccountCreated,
        children: [
          {
            path: '/',
            element: <AccountCreated />
          }
        ]
      },
      {
        path: Page.Forget,
        children: [
          {
            path: 'password',
            element: <Forgetemail />
          },
          {
            path: 'authcode',
            element: <Forgetauth />
          }
        ]
      },
      {
        path: Page.ResetPassword,
        element: <ResetPassword />
      },
      {
        path: Page.UpdatePhone,
        element: <UpdatePhone />
      },
      {
        path: Page.MFAMethod,
        element: <MFAMethod />
      },
      {
        path: Page.MFACode,
        element: <MFACode />
      },
      {
        path: 'status',
        children: [
          {
            path: '/',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: ':state/*',
    element: (
      <ProtectedRoute>
        <SidebarLayout />
      </ProtectedRoute>
    ),
    children: [
      // {
      //   path: AmacUrl.Rules,
      //   children: [
      //     {
      //       path: '/',
      //       element: <CaseSettingsS3 />
      //     }
      //   ]
      // }
    ]
  },

  {
    path: ':state',
    element: (
      <ProtectedRoute>
        <SidebarLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'status',
        children: [
          {
            path: '/',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '/',
        element: <Navigate to={Page.Dashboard} replace />
      },
      {
        path: `${Page.Dashboard}/`,
        element: <Test />
      },
      {
        path: `${Page.VotersFuzzySearch}/`,
        element: <VotersFuzzySearch />
      },
      {
        path: `${Page.Test}/`,
        element: <Home />
      },
      {
        path: `${Page.Analytics}/`,
        element: <Analytics />
      },
      {
        path: `${Page.GeneralElections2024}/`,
        element: <Analytics />
      },
      {
        path: `${Page.PrimaryElections2025}/`,
        element: <PrimaryElections2025 />
      },
      {
        path: `${Page.PrimaryElectionsNov2025}/`,
        element: <PrimaryElectionsNov2025 />
      },
      {
        path: `${Page.UsersManagement}/`,
        element: <UsersManagement />
      },
      {
        path: `${Page.CandidatesLogs}/`,
        element: <CandidatesLogs />
      },
      
      
      
      {
        path: `${Page.LoginLogs}/`,
        element: <LoginLogs />
      },
      {
        path: `${Page.VotersListingLogs}/`,
        element: <VotersListingLogs />
      },
      {
        path: `${Page.VotersListing}/`,
        element: <VotersListing />
      },
      {
        path: `${Page.CommunityDemographics}/`,
        element: <CommunityDemographics />
      },

      {
        path: `${Page.Voters}/`,
        element: <SearchUserDynamoDB />
      },
      {
        path: `${Page.SearchUserClickHouse}/`,
        element: <SearchUserClickHouse />
      },
      {
        path: `${Page.AddOwnership}/`,
        element: <AddOwnership />
      },
      {
        path: `${Page.Reasons}/`,
        element: <Reasons />
      },
      {
        path: `${Page.ChorplethMap}/`,
        element: <ChorplethMap />
      },
      {
        path: `${Page.CustomVotersListing}/`,
        element: <CustomVotersListing />
      },
      {
        path: Page.VoterTurnout,
        element: <VoterTurnout />
      },
      {
        path: Page.VoterPopulation,
        element: <VoterPopulation />
      },
      {
        path: Page.SamplePage,
        element: <SamplePage />
      },
      
      {
        path: Page.CSVUpload,
        element: <CSVUpload />
      },
      {
        path: `${Page.Contacts}/`,
        element: <Contacts />
      },
      {
        path: `${Page.CaptainsRelations}/`,
        element: <CaptainsRelations />
      }

      // {
      //   path: `${Page.AdvanceSearch}`,
      //   element: <AdvanceSearch />
      // }
      // ,
      // {PSTPIIDocuments
      //   path: 'Test',
      //   element: <Test />
      // }
    ]
  },

  //Old Paths
  {
    path: ':state/dashboard',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboards/crypto" replace />
      },
      {
        path: 'messenger',
        element: <Messenger />
      }
    ]
  },
  {
    path: ':state/management',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/management/transactions" replace />
      },
      {
        path: 'transactions',
        element: <Transactions />
      },
      {
        path: 'profile',
        children: [
          {
            path: '/',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },
  {
    path: ':state/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/components/buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;
